module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-logo"
  }, [(_vm.myhost === 'hoodafinancehrm.com') ? _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }) : _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://demo.micromuneem.com/MicroMuneem-Logo.webp",
      "width": "200px"
    }
  })])], 1), _vm._v(" "), (this.type === 'login') ? _c('div', {
    staticClass: "login-box-body text-center",
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "0px 0px 10px gray"
    }
  }, [(_vm.logo) ? _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "width": "155px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "login-box-msg text-blue"
  }, [_vm._v("Sign in to start your session")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "email",
      "checked": "",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.form.type, "email")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "type", "email")
      }
    }
  }), _vm._v("Email\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "mobile",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.form.type, "mobile")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "type", "mobile")
      }
    }
  }), _vm._v("Mobile\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "code",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.form.type, "code")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "type", "code")
      }
    }
  }), _vm._v("User Code\n          ")]), _vm._v(" "), (_vm.form.type == 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.type == 'mobile') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobile),
      expression: "form.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mobile",
      "type": "number",
      "placeholder": "Mobile Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobile", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.type == 'code') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "code",
      "type": "text",
      "placeholder": "Code Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-envelope form-control-feedback"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.error),
      expression: "error.error"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Credentials that you've entered is " + _vm._s(_vm.error.error))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.forgetPassword
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Forgot Password")]), _vm._v("        \n      ")], 1) : _vm._e(), _vm._v(" "), (this.type === 'forget') ? _c('div', {
    staticClass: "login-box-body text-center",
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "gray 0px 0px 10px"
    }
  }, [(_vm.logo) ? _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "width": "155px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Please Enter Registered Email/Mobile Number")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.verifyMobile($event)
      }
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "email",
      "checked": "",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.form.type, "email")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "type", "email")
      }
    }
  }), _vm._v("Email\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "mobile",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.form.type, "mobile")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "type", "mobile")
      }
    }
  }), _vm._v("Mobile\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    attrs: {
      "type": "radio",
      "name": "type",
      "value": "code",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.form.type, "code")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "type", "code")
      }
    }
  }), _vm._v("Code\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [(_vm.form.type == 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "abc@gmail.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.type == 'mobile') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobile),
      expression: "form.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mobile",
      "type": "number",
      "placeholder": "Mobile Number",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobile", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.type == 'code') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "code",
      "type": "text",
      "placeholder": "code",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-phone form-control-feedback"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.error),
      expression: "error.error"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Credentials that you've entered is " + _vm._s(_vm.error.error))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.backLogin
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Back to login")])]), _vm._v(" "), _vm._m(1)])])], 1) : _vm._e(), _vm._v(" "), (this.type === 'otp') ? _c('div', {
    staticClass: "login-box-body text-center",
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "0px 0px 10px gray"
    }
  }, [(_vm.logo) ? _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "width": "155px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Please Enter One Time Password (OTP)")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.verifyOTP($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.otp),
      expression: "form.otp"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "otp",
      "type": "number",
      "placeholder": "Please Enter OTP",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.otp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "otp", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-phone form-control-feedback"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.error),
      expression: "error.error"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Credentials that you've entered is " + _vm._s(_vm.error.error))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.forgetPassword
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Resend OTP")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.backLogin
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Back to login")])]), _vm._v(" "), _vm._m(2)])])], 1) : _vm._e(), _vm._v(" "), (this.type === 'confirmPassword') ? _c('div', {
    staticClass: "login-box-body"
  }, [_c('p', {
    staticClass: "login-box-msg"
  }, [_vm._v("Please Enter Password")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirmPassword($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.confirm_password),
      expression: "form.confirm_password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "confirm_password",
      "type": "password",
      "placeholder": "Confirm Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.confirm_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "confirm_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-lock form-control-feedback"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.error),
      expression: "error.error"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" The password that you've entered is " + _vm._s(_vm.error.error))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.backLogin
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Back to login")])]), _vm._v(" "), _vm._m(3)])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "",
      "id": "flexCheckChecked",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "flexCheckChecked"
    }
  }, [_vm._v("\n                Remember Me\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-block btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign In")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send OTP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Verify OTP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-flat",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Reset Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa708034!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comman/login.vue
// module id = 856
// module chunks = 0